import ApiService from './ApiService'

const BillingEntityService = {
    async get(billingEntity) {
        const { data } = await ApiService.get('billing_entity.show', { billing_entity: billingEntity })
        return data
    },

    create(data) {
        return ApiService.post('billing_entity.store', data)
    },

    update(billingEntity, data) {
        return ApiService.post('billing_entity.update', data, { billing_entity: billingEntity })
    },

    async downloadLogo(billingEntity) {
        try {
            const fileName = `billing_entity_${billingEntity.id}_logo`
            await ApiService.downloadFile('billing_entity.logo.download', fileName, {
                billing_entity: billingEntity.id,
            })
        } catch (error) {
            console.error('Error downloading billing entity logo:', error)
            throw error
        }
    },
}

export default BillingEntityService
